export const VERSION = 'Beta-v2.4.1';
export const PRODUCT_NAME = 'Dealer Bosses';
export const COPYRIGHT_YEAR = new Date().getFullYear();
export const COPYRIGHT_COMPANY = 'LLnet Research & Development Canada';
